import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, Card, CardBody, Col, FormGroup, Input, Label, Row } from 'reactstrap'
import Select from 'react-select'
import { reactSelectStyles } from '../variables/react-select-styles'
import api from '../api'
import { useDispatch, useSelector } from 'react-redux'
import { setExchanges } from '../redux/actions/exchagesActions'
import { logOut } from '../helpers/hooks'
import { setError, setSuccess } from '../redux/actions/alertActions'
import { isAdmin, isUser } from '../helpers/roles'
import { reactSelectLightStyles } from '../variables/react-select-light-styles'
import { styleFlexColumn, styleFlexRow } from '../helpers/stylesHelpers'
import '../helpers/styles/buttons.css'
import ConfirmModal from '../components/ConfirmModal/ConfirmModal'
import { useTranslation } from 'react-i18next'

const ApiKeysForm = () => {
  const navigate = useNavigate()
  if (!(isAdmin() || isUser())) {
    navigate('/access-denied')
  }
  const { id } = useParams()
  const dispatch = useDispatch()
  const exchangesData = useSelector(state => state.exchanges)
  const keysSetsData = useSelector(state => state.keysSets)
  const cid = JSON.parse(localStorage.getItem('user'))?.cid
  const isUpdate = !!id
  let isTest = false

  const [formData, setFormData] = useState({
    name: '',
    exchange: null,
    keys: [],
  })
  const [formControlData, setFormControlData] = useState({
    botUpdating: false,
    botDeletingId: 0,
    confirmBotTokenId: 0,
    confirmBotTokenName: '',
    modalIsOpen: false,
  })

  const [formNewBotTokenAddress, setFormNewBotTokenAddress] = useState({
    bot_id: parseInt(id),
    token_name: '',
    token_address: '',
    min_balance: 0.0,
  })

  const { t } = useTranslation()

  const resetFormNewBotTokenAddress = () =>
    setFormNewBotTokenAddress({
      bot_id: parseInt(id),
      token_name: '',
      token_address: '',
      min_balance: 0.0,
    })

  const [formUpdateBotTokenAddress, setFormUpdateBotTokenAddress] = useState({
    id: 0,
    bot_id: parseInt(id),
    token_name: '',
    token_address: '',
    min_balance: 0.0,
  })

  const [formBotTokenAddresses, setFormBotTokenAddresses] = useState({
    value: [],
  })

  useEffect(() => {
    if (cid) {
      api
        .getExchanges()
        .then(res => {
          if (res.exchanges) {
            dispatch(setExchanges(res.exchanges))
          }
        })
        .catch(e => console.error('getExchanges error ', e))
    } else {
      logOut()
    }
  }, [])

  const getBotTokenAddressNumber = id => formBotTokenAddresses.value.findIndex(a => a.id === id) + 1

  const getBotTokenAddressItemView = botTokenItem => (
    <div style={styleFlexColumn}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
        <div style={{ fontSize: '1.1rem', color: '#247bf7c7' }}>
          #{getBotTokenAddressNumber(parseInt(botTokenItem.id))}
        </div>
      </div>
      <div>
        <form>
          <FormGroup>
            <Label for='token_name'>{t('apiKeysForm.name')}</Label>
            <Input
              type='text'
              name='token_name'
              placeholder={t('apiKeysForm.placeholders.name')}
              value={
                formUpdateBotTokenAddress.id !== botTokenItem.id
                  ? botTokenItem.token_name
                  : formUpdateBotTokenAddress.token_name
              }
              onChange={e => handleUpdateBotTokenChange('token_name', e.target.value)}
              required
              disabled={formUpdateBotTokenAddress.id !== botTokenItem.id}
            />
          </FormGroup>
          <FormGroup>
            <Label for='token_address'>{t('apiKeysForm.address')}</Label>
            <Input
              type='text'
              name='token_address'
              placeholder={t('apiKeysForm.placeholders.address')}
              value={
                formUpdateBotTokenAddress.id !== botTokenItem.id
                  ? botTokenItem.token_address
                  : formUpdateBotTokenAddress.token_address
              }
              onChange={e => handleUpdateBotTokenChange('token_address', e.target.value)}
              required
              disabled={formUpdateBotTokenAddress.id !== botTokenItem.id}
            />
          </FormGroup>
          <FormGroup>
            <Label for='exchange'>{t('apiKeysForm.minBalance')}</Label>
            <Input
              type='number'
              name='min_balance'
              placeholder={t('apiKeysForm.placeholders.minBalance')}
              value={
                formUpdateBotTokenAddress.id !== botTokenItem.id
                  ? botTokenItem.min_balance
                  : formUpdateBotTokenAddress.min_balance
              }
              onChange={e => handleUpdateBotTokenChange('min_balance', parseFloat(e.target.value))}
              required
              disabled={formUpdateBotTokenAddress.id !== botTokenItem.id}
            />
          </FormGroup>
        </form>
      </div>
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'end',
          gap: '5px',
        }}>
        <div
          className={'button-white'}
          onClick={e => onClickBotTokenDelete(e, parseInt(botTokenItem.id))}>
          {formControlData.botDeletingId === botTokenItem.id
            ? t('apiKeysForm.buttons.deleting')
            : t('apiKeysForm.buttons.delete')}
        </div>
        {formUpdateBotTokenAddress.id === botTokenItem.id && (
          <div
            className={'button-white'}
            onClick={onClickBotTokenCancelChange}
            disabled={formControlData.botUpdating}>
            {t('apiKeysForm.buttons.cancel')}
          </div>
        )}
        {formUpdateBotTokenAddress.id === botTokenItem.id && (
          <Button
            onClick={onClickBotTokenSave}
            color='primary'
            disabled={
              formControlData.botUpdating ||
              !(
                formUpdateBotTokenAddress.token_address &&
                formUpdateBotTokenAddress.token_name &&
                formUpdateBotTokenAddress.min_balance >= 0
              )
            }>
            {t('apiKeysForm.buttons.save')}
          </Button>
        )}
        {formUpdateBotTokenAddress.id !== botTokenItem.id && (
          <Button
            color='primary'
            onClick={e => onClickBotTokenChange(e, botTokenItem)}
            disabled={formControlData.botUpdating}>
            {t('apiKeysForm.buttons.change')}
          </Button>
        )}
      </div>
    </div>
  )

  const updateBotTokens = res => {
    setFormBotTokenAddresses({ value: res ?? [] })
  }

  useEffect(() => {
    if (isTest)
      updateBotTokens([
        {
          id: 123,
          bot_id: parseInt(id),
          min_balance: 120.0,
          token_address: 'qqwqwqw',
          token_name: 'asdas',
        },
      ])
  }, [isTest])

  useEffect(() => {
    if (isUpdate) {
      const editedKey = keysSetsData.keysSets.find(key => key.id === parseInt(id, 10))
      if (editedKey) {
        const selectedExchange = exchangesData.exchanges.find(
          exchange => exchange.name === editedKey.exchange,
        )
        setFormNewBotTokenAddress({
          bot_id: parseInt(id),
          min_balance: 0.0,
          token_address: null,
          id: null,
          token_name: null,
        })
        emptyBotTokenAddress.bot_id = parseInt(id)
        setFormData({
          name: editedKey.name,
          exchange: {
            value: selectedExchange?.eid,
            label: selectedExchange?.name,
          },
          keys: [editedKey.key1, editedKey.key2, editedKey.key3].filter(Boolean),
        })
        getBotTokenAddresses()
      }
    } else {
      if (cid) {
        if (!exchangesData.exchanges.length) {
          api
            .getExchanges()
            .then(res => {
              if (res.exchanges) {
                dispatch(setExchanges(res.exchanges))
              }
            })
            .catch(e => console.error('getExchanges error ', e))
        }
      } else {
        logOut()
      }
    }
  }, [id, exchangesData, isUpdate])

  const getBotTokenAddresses = () => {
    setFormControlData({
      ...formControlData,
      botUpdating: true,
      modalIsOpen: false,
      botDeletingId: 0,
      confirmBotTokenId: 0,
      confirmBotTokenName: '',
    })
    api
      .getBotTokenAddresses(id)
      .then(res => {
        setFormControlData({
          ...formControlData,
          botUpdating: false,
        })
        if (res) {
          updateBotTokens(res)
        }
      })
      .catch(e => {
        dispatch(setError(t('apiKeysForm.errors.receive')))
        setFormControlData({ ...formControlData, botUpdating: false })
        console.error('getBotTokenAddresses error ', e)
      })
  }

  const handleChange = (name, value) => {
    setFormData({ ...formData, [name]: value })
  }

  const handleNewBotTokenChange = (name, value) => {
    setFormNewBotTokenAddress({ ...formNewBotTokenAddress, [name]: value })
  }

  const handleUpdateBotTokenChange = (name, value) => {
    setFormUpdateBotTokenAddress({ ...formUpdateBotTokenAddress, [name]: value })
  }

  const handleExchangeChange = selectedOption => {
    handleChange('exchange', selectedOption)
  }

  const handleKeyChange = (value, index) => {
    const updatedKeys = [...formData.keys]
    updatedKeys[index] = value
    setFormData({ ...formData, keys: updatedKeys })
  }

  const onClickBotTokenAdd = async e => {
    e.preventDefault()
    setBotUpdating(true)

    api
      .createBotTokenAddress({ ...formNewBotTokenAddress, bot_id: parseInt(id) })
      .then(res => {
        setFormNewBotTokenAddress({ ...emptyBotTokenAddress })
        getBotTokenAddresses()
      })
      .catch(e => {
        dispatch(setError(t('apiKeysForm.errors.create')))
        console.error('createBotTokenAddress error ', e)
      })
      .finally(() => setBotUpdating(false))
  }

  const emptyBotTokenAddress = {
    id: 0,
    bot_id: parseInt(id),
    token_name: '',
    token_address: '',
    min_balance: 0.0,
  }

  const onClickBotTokenCancelChange = async e => {
    e?.preventDefault()
    setFormUpdateBotTokenAddress({ ...emptyBotTokenAddress })
  }

  const setBotUpdating = value => setFormControlData({ ...formControlData, botUpdating: value })

  const onClickBotTokenSave = async e => {
    e.preventDefault()
    setBotUpdating(true)
    api
      .updateBotTokenAddress({ ...formUpdateBotTokenAddress, bot_id: parseInt(id) })
      .then(res => {
        setFormUpdateBotTokenAddress({ ...emptyBotTokenAddress })
        getBotTokenAddresses()
      })
      .catch(e => {
        dispatch(setError(t('apiKeysForm.errors.update')))
        console.error('updateBotTokenAddress error ', e)
      })
      .finally(() => setBotUpdating(false))
  }
  const onClickBotTokenChange = async (e, botToken) => {
    e.preventDefault()
    setFormUpdateBotTokenAddress({ ...botToken })
  }
  const toggleConfirmModal = e => {
    setFormControlData({
      ...formControlData,
      confirmBotTokenName: '',
      confirmBotTokenId: 0,
      modalIsOpen: false,
    })
  }

  const confirmDeleteBotToken = () => {
    const id = formControlData.confirmBotTokenId
    if (!id) {
      setFormControlData({
        ...formControlData,
        confirmBotTokenId: 0,
        confirmBotTokenName: '',
        modalIsOpen: false,
      })
      return
    }
    deleteBotToken(id)
  }

  const deleteBotToken = id => {
    setFormControlData({
      ...formControlData,
      botDeletingId: id,
    })
    const deletingToken = getBotTokenById(id)
    const tokenName = deletingToken.token_name
    api
      .deleteBotTokenAddress(id)
      .then(r => getBotTokenAddresses())
      .catch(e => {
        dispatch(setError(`${t('apiKeysForm.errors.delete')}: ${tokenName}`))
        console.error('deleteBotTokenAddress error ', e)
        setFormControlData({
          ...formControlData,
          botUpdating: false,
          modalIsOpen: false,
        })
      })
  }
  const getBotTokenById = id => {
    return formBotTokenAddresses.value.find(a => a.id === id)
  }
  const onClickBotTokenDelete = async (e, id) => {
    e?.preventDefault()
    const botToken = getBotTokenById(id)
    setFormControlData({
      ...formControlData,
      botUpdating: false,
      confirmBotTokenId: id,
      confirmBotTokenName: botToken.token_name,
      modalIsOpen: true,
    })
  }

  const handleSubmit = async e => {
    e.preventDefault()

    const requestBody = {
      name: formData.name,
      exchange: formData.exchange.label,
      key1: formData.keys[0],
      key2: formData.keys[1],
    }

    if (formData.keys[2]) {
      requestBody.key3 = formData.keys[2]
    }

    if (isUpdate) {
      requestBody.id = parseInt(id)
      requestBody.active = true
      api
        .updateApiKey(requestBody)
        .then(res => {
          if (res.success) {
            dispatch(setSuccess(t('apiKeysForm.success.update', { name: formData.name })))
            navigate('/admin/apikeys')
          }
        })
        .catch(e => console.error('updateApiKey error ', e))
    } else {
      requestBody.cid = cid
      api
        .createApiKey(requestBody)
        .then(res => {
          if (res.id) {
            dispatch(setSuccess(t('apiKeysForm.success.create', { name: formData.name })))
            navigate('/admin/apikeys')
          }
        })
        .catch(e => console.error('createApiKey error ', e))
    }
  }

  const exchangeOptions =
    exchangesData?.exchanges?.map(exchange => ({
      value: exchange.eid,
      label: exchange.name,
    })) || []

  const selectedExchange = exchangesData.exchanges.find(
    exchange => exchange.eid === formData.exchange?.value,
  )

  const keyInputs =
    selectedExchange &&
    Array.from({ length: selectedExchange.keys_num }).map((_, index) => {
      return (
        <FormGroup key={index}>
          <Label for={`key${index + 1}`}>{`${t('apiKeysForm.key')} ${index + 1}`}</Label>
          <Input
            type='text'
            name={`key${index + 1}`}
            id={`key${index + 1}`}
            placeholder={t('apiKeysForm.placeholders.key', { number: index + 1 })}
            value={(!isAdmin() && index > 0) ? '****************' : formData.keys[index] || ''}
            onChange={e => handleKeyChange(e.target.value, index)}
            required
            readOnly={!isAdmin()}
          />
        </FormGroup>
    )})
  const getBotTokeViews = value => {
    return Array.from(value).map((_, index) => getBotTokenAddressItemView(_))
  }
  return (
    <div className='content'>
      <Row>
        <Col className='' xl={6}>
          <Card>
            <CardBody>
              <div style={{ ...styleFlexRow, justifyContent: 'space-between' }}>
                <h2>{isUpdate ? t('apiKeysForm.editTitle') : t('apiKeysForm.addTitle')}</h2>
                {isUpdate && (
                  <h4 onClick={e => navigate("orders")}>
                    <div
                      style={{
                        cursor: 'pointer',
                        textDecoration: 'underline',
                        userSelect: 'none',
                      }}>
                      {t('apiKeysForm.orders')}
                    </div>
                  </h4>
                )}
              </div>
              <form>
                <FormGroup>
                  <Label for='name'>{t('apiKeysForm.name')}</Label>
                  <Input
                    type='text'
                    name='name'
                    id='name'
                    placeholder={t('apiKeysForm.placeholders.name')}
                    value={formData.name}
                    onChange={e => handleChange('name', e.target.value)}
                    required
                    disabled={isUpdate}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for='exchange'>{t('apiKeysForm.exchange')}</Label>
                  <Select
                    options={exchangeOptions}
                    value={formData.exchange}
                    onChange={handleExchangeChange}
                    placeholder={t('apiKeysForm.select.exchange')}
                    styles={
                      localStorage.getItem('darkMode') === 'true'
                        ? reactSelectStyles(isUpdate)
                        : reactSelectLightStyles(isUpdate)
                    }
                    required
                    isDisabled={isUpdate}
                    noOptionsMessage={() => t('select.noOptionsMessage')}
                  />
                </FormGroup>
                {keyInputs}
                <div className='w-100 d-flex' style={{ justifyContent: 'flex-end' }}>
                  {isAdmin() && <Button color='primary' onClick={handleSubmit}>
                    {isUpdate ? t('apiKeysForm.buttons.update') : t('apiKeysForm.buttons.add')}
                  </Button>}
                </div>
              </form>

              {isUpdate && (
                <div>
                  <div
                    style={{
                      ...styleFlexRow,
                      justifyContent: 'space-between',
                      marginTop: '20px',
                    }}>
                    <h3>{t('apiKeysForm.botTokenAddresses')}</h3>
                  </div>
                  <div style={styleFlexColumn}>
                    {formBotTokenAddresses.value.length > 0 && (
                      <div style={{ ...styleFlexColumn, gap: '20px' }}>
                        {getBotTokeViews(formBotTokenAddresses.value)}
                      </div>
                    )}

                    {formBotTokenAddresses.value.length === 0 && (
                      <h5 style={{ paddingLeft: '20px' }}>{t('apiKeysForm.noItems')}</h5>
                    )}

                    {isUpdate && (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          paddingTop: '30px',
                        }}>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}>
                          <div style={{ fontSize: '1.1rem', color: '#247bf7c7' }}>
                            {t('apiKeysForm.newBotTokenAddress')}
                          </div>
                        </div>
                        <div>
                          <form>
                            <FormGroup key={'token_name'}>
                              <Label for='token_name'>{t('apiKeysForm.name')}</Label>
                              <Input
                                type='text'
                                name='token_name'
                                placeholder={t('apiKeysForm.placeholders.name')}
                                value={formNewBotTokenAddress.token_name}
                                onChange={e =>
                                  handleNewBotTokenChange('token_name', e.target.value)
                                }
                                required
                              />
                            </FormGroup>
                            <FormGroup key={'token_address'}>
                              <Label for='token_address'>{t('apiKeysForm.address')}</Label>
                              <Input
                                type='text'
                                name='token_address'
                                placeholder={t('apiKeysForm.placeholders.address')}
                                value={formNewBotTokenAddress.token_address}
                                onChange={e =>
                                  handleNewBotTokenChange('token_address', e.target.value)
                                }
                                required
                              />
                            </FormGroup>
                            <FormGroup key={'min_balance'}>
                              <Label for='min_balance'>{t('apiKeysForm.minBalance')}</Label>
                              <Input
                                type='number'
                                name='min_balance'
                                placeholder={t('apiKeysForm.placeholders.minBalance')}
                                value={formNewBotTokenAddress.min_balance}
                                onChange={e =>
                                  handleNewBotTokenChange('min_balance', parseFloat(e.target.value))
                                }
                                required
                              />
                            </FormGroup>
                          </form>
                        </div>
                        <div
                          style={{
                            justifyContent: 'end',
                            width: '100%',
                            display: 'flex',
                            gap: '5px',
                          }}>
                          <Button
                            color='primary'
                            onClick={onClickBotTokenAdd}
                            disabled={
                              !(
                                formNewBotTokenAddress.token_name &&
                                formNewBotTokenAddress.token_address &&
                                formNewBotTokenAddress.min_balance >= 0
                              ) || formControlData.botUpdating
                            }>
                            {t('apiKeysForm.buttons.add')}
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </CardBody>
          </Card>
          <ConfirmModal
            isOpen={formControlData.modalIsOpen}
            toggle={toggleConfirmModal}
            onConfirm={confirmDeleteBotToken}
            text={t('apiKeysForm.confirmDelete', {
              name: formControlData.confirmBotTokenName,
            })}
          />
        </Col>
      </Row>
    </div>
  )
}

export default ApiKeysForm
